import { useInitialDataImplementation } from "@/hooks/implementation/firstLoad/initialDataImplementation";

import AfterButton from "./AfterButton";
import BeforeButton from "./BeforeButton";
import SaveButton from "./SaveButton";
import FinishButton from "./FinishButton";

export const FooterButtons = ({ wizard, currentIndex, handleSave, isLoading, unitaryLoadSelected = false, handleFinish = null }) => {
	const { data } = useInitialDataImplementation();

	const handleNext = (forward) => {
		handleSave({ moveForward: forward });
	};

	const handlePrev = () => {
		if (wizard.current?.prevTab) {
			wizard.current.prevTab();
		}
	};

	const handleTerminate = () => {
		if (handleFinish) {
			handleFinish();
		}
	};

	return (
		<div className="row justify-content-center">
			<div className="col-md-11">
				<div className="row mb-3">
					<div className="col-md-4">{currentIndex > 0 && <BeforeButton handlePrev={handlePrev} lockNextBtn={isLoading} />}</div>
					<div className="col-md-4">
						{currentIndex < data.totalSteps - 1 ? <SaveButton handleSave={() => handleNext(false)} lockNextBtn={isLoading} /> : <></>}
					</div>
					<div className="col-md-4">
						{currentIndex < data.totalSteps - 1 && !data.isComplete ? (
							<AfterButton handleNext={() => handleNext(true)} lockNextBtn={isLoading} />
						) : (
							<></>
						)}
						{currentIndex === data.totalSteps - 1 && !data.isComplete ? (
							<div className="btn btn-group float-right">
								<FinishButton unitaryLoadSelected={unitaryLoadSelected} handleSave={handleTerminate} lockNextBtn={isLoading} />
							</div>
						) : (
							<></>
						)}
					</div>
				</div>
			</div>
		</div>
	);
};

export default FooterButtons;
